(function () {
    "use strict";

    angular
        .module("app")
        .directive("statusDropdown", ["StatusService", statusDropdown]);

    function statusDropdown(statusService) {
        return {
            restrict: "E",
            link: function (scope) {
                scope.statuses = [];

                statusService.getStatusList().then(function (response) {
                    if (response) {
                        scope.statuses = response;
                        if (scope.showGroups.toString() === "true") {
                            scope.statuses.splice(0, 0, { StatusId: 9999, StatusName: "All Active (Created/Released/Completed)" });
                            scope.statuses.splice(0, 0, { StatusId: 9998, StatusName: "All Active (Created/Released)" });
                        }
                    }
                });

            },
            scope: { selectedValue: "=", showGroups: "@" },
            template: '<select class="form-control"'
            + ' ng-options="item.StatusId as item.StatusName for item in statuses"'
            + ' ng-model="selectedValue">'
            + ' <option value="">-- Select Status --</option>'
            + ' </select>'
        };
    }
})();

